export var TimePeriodGroupBy;
(function (TimePeriodGroupBy) {
    TimePeriodGroupBy["Days"] = "day";
    TimePeriodGroupBy["Hours"] = "hour";
})(TimePeriodGroupBy || (TimePeriodGroupBy = {}));
export var ModelType;
(function (ModelType) {
    ModelType["Text"] = "text";
    ModelType["Metric"] = "metric";
})(ModelType || (ModelType = {}));
//# sourceMappingURL=common.js.map